module.exports = __webpack_public_path__ + "static/2026_vinnarar_2-34cb3b3e7d1812dadfd23765cadf32cc.jpg";